import React from 'react';

// The office sales screen: Day, Week, Month, Year. Every figure comes from the
// server's /api/sales/board, which does the sums; this only lays them out.

const gbp = (n) => (n === null || n === undefined ? '-'
  : new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }).format(n));

export const ukDate = (iso) => (iso ? iso.split('-').reverse().join('/') : '');

export const londonTime = (ts) => (ts ? new Date(ts).toLocaleTimeString('en-GB', {
  timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit',
}) : '');

// Needed to hit target, or how far past it the team already is.
const Needed = ({ needed }) => (needed > 0
  ? <><span className="sb-k">Sales needed</span><span className="sb-v">{gbp(needed)}</span></>
  : <><span className="sb-k">Target beaten by</span><span className="sb-v sb-good">{gbp(-needed)}</span></>);

const Progress = ({ sales, target }) => {
  const pct = target > 0 ? Math.max(0, Math.min(100, (sales / target) * 100)) : 0;
  return (
    <div className="sb-bar" aria-label={`${Math.round(pct)}% of target`}>
      <div className={`sb-bar-fill ${pct >= 100 ? 'sb-bar-done' : ''}`} style={{ width: `${pct}%` }} />
    </div>
  );
};

const Row = ({ title, p, label, unit }) => (
  <div className="sb-row">
    <div className="sb-head">
      <div className="sb-title">{title}</div>
      <div className="sb-range">{label}</div>
    </div>
    <div className="sb-main">
      <div className="sb-big">{gbp(p.sales)}</div>
      <div className="sb-target">of {gbp(p.target)} target</div>
      <Progress sales={p.sales} target={p.target} />
    </div>
    <div className="sb-pair"><Needed needed={p.needed} /></div>
    {p.average !== undefined && (
      <>
        <div className="sb-pair">
          <span className="sb-k">{unit} average</span>
          <span className="sb-v">{gbp(p.average)}</span>
          <span className="sb-note">{p.working_days_so_far} of {p.working_days_in_period} working days</span>
        </div>
        <div className="sb-pair">
          <span className="sb-k">{unit} forecast</span>
          <span className={`sb-v ${p.forecast_vs_target === null ? '' : p.forecast_vs_target >= 0 ? 'sb-good' : 'sb-bad'}`}>
            {p.forecast_vs_target === null ? '-' : `${p.forecast_vs_target >= 0 ? '+' : '-'}${gbp(Math.abs(p.forecast_vs_target))}`}
          </span>
          <span className="sb-note">on track for {gbp(p.forecast_total)}</span>
        </div>
      </>
    )}
  </div>
);

const SalesBoardTiles = ({ board }) => (
  <div className="sb-grid">
    <Row title="Current Day" p={board.day} label={ukDate(board.today)} />
    <Row title="Current Week" p={board.week} unit="Weekly" label={`${ukDate(board.week.start)} to ${ukDate(board.week.end)}`} />
    <Row title="Current Month" p={board.month} unit="Monthly" label={new Date(`${board.today}T12:00:00Z`).toLocaleDateString('en-GB', { month: 'long', year: 'numeric', timeZone: 'UTC' })} />
    <Row title="Current Year" p={board.year} unit="Yearly" label={board.today.slice(0, 4)} />
  </div>
);

// True when the collector has not posted for over 30 minutes during the hours it runs (06:00 to 23:45 London).
export const feedIsStale = (board) => {
  if (!board?.last_feed_at) return true;
  const hour = Number(new Date().toLocaleString('en-GB', { timeZone: 'Europe/London', hour: '2-digit', hour12: false }));
  if (hour < 7) return false;
  return Date.now() - new Date(board.last_feed_at).getTime() > 30 * 60 * 1000;
};

export default SalesBoardTiles;
